import React, { useState } from 'react';

function PdfTocAnalysis({ token }) {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
        setError(null);
    };

    const handleUpload = async () => {
        if (!file) {
            setError('Please select a file first.');
            return;
        }

        setLoading(true);
        setError(null);
        setResult(null);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch('/api/pdf/analyze-toc', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                },
                body: formData
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to extract ToC');
            }

            const data = await response.json();
            setResult(data);
        } catch (err) {
            console.error('Error extracting ToC:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="card shadow-sm mt-4 text-start">
            <div className="card-body">
                <h3 className="card-title text-center">PDF ToC Extraction</h3>
                <div className="mb-3">
                    <input 
                        type="file" 
                        className="form-control" 
                        accept=".pdf" 
                        onChange={handleFileChange} 
                    />
                </div>
                <div className="text-center">
                    <button 
                        onClick={handleUpload} 
                        className="btn btn-primary" 
                        disabled={loading || !file}
                    >
                        {loading ? 'Extracting...' : 'Extract ToC'}
                    </button>
                </div>

                {error && (
                    <div className="alert alert-danger mt-3">
                        {error}
                    </div>
                )}

                {result && (
                    <div className="mt-4">
                        <h5>Extracted Table of Contents:</h5>
                        <div className="list-group mt-2">
                            {result.sections && result.sections.map((section, sIdx) => (
                                <div key={sIdx} className="list-group-item">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <strong>{section.sectionName}</strong>
                                        <span className="badge bg-secondary rounded-pill">Page {section.pageNr}</span>
                                    </div>
                                    {section.subSections && section.subSections.length > 0 && (
                                        <ul className="list-group list-group-flush mt-2">
                                            {section.subSections.map((sub, ssIdx) => (
                                                <li key={ssIdx} className="list-group-item d-flex justify-content-between align-items-center border-0 ps-4">
                                                    <span>{sub.subSectionName}</span>
                                                    <span className="text-muted small">Page {sub.pageNr}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            ))}
                        </div>
                        <details className="mt-3">
                            <summary className="text-muted cursor-pointer">Show Raw JSON</summary>
                            <pre className="bg-gradient p-3 border rounded mt-2">
                                <code>{JSON.stringify(result, null, 2)}</code>
                            </pre>
                        </details>
                    </div>
                )}
            </div>
        </div>
    );
}

export default PdfTocAnalysis;
